import { Interval } from 'app/agriculture/AgTimeline/types';
import { differenceInMilliseconds } from 'date-fns';

export function percentageOfInterval(time: Date, { start, end }: Interval<Date>) {
    // end shouldn't be before start
    if (end < start) return 0;

    // this avoids dividing by 0
    const intervalDurationInMilliseconds = differenceInMilliseconds(end, start);
    if (intervalDurationInMilliseconds === 0) return 1;

    return differenceInMilliseconds(time, start) / differenceInMilliseconds(end, start);
}
